import React, { useState, useEffect } from "react";
import { SITE_TITLE } from "./constants";
import Header from "./components/Header";
import StoriesContainer from "./containers/StoriesContainer";
import "./App.css";

function App() {
  useEffect(() => {
    // Update the document title using the browser API
    document.title = `${SITE_TITLE}`;
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  const [reload, setReload] = useState(new Date());

  const refreshFeed = () => {
    setIsLoading(true);
    setReload(new Date());
  };

  return (
    <div className="app">
      <Header
        refreshFeed={refreshFeed}
        isLoading={isLoading}
        siteTitle={SITE_TITLE}
      />
      <StoriesContainer
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        reload={reload}
      />
    </div>
  );
}

export default App;
